exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trust-banner[data-v-0e385bb7] {\n  margin-top: var(--size-xl);\n}\n.trust-banner__item[data-v-0e385bb7] {\n  text-align: center;\n}\n.trust-banner__item > img[data-v-0e385bb7] {\n  width: 100px;\n  margin-bottom: var(--size-base);\n}\n@media screen and (max-width: 992px) {\n.trust-banner__item > img[data-v-0e385bb7] {\n    width: 75px;\n}\n}\n.trust-banner__item > h3[data-v-0e385bb7] {\n  color: var(--gray-700);\n  font-size: var(--size-base);\n}\n@media screen and (max-width: 992px) {\n.trust-banner__item > h3[data-v-0e385bb7] {\n    font-size: 10px;\n}\n}", ""]);

// exports
